<div mat-dialog-title>
		<div fxFlex="90" fxLayoutAlign="start center">{{'trackOrderDetailsView.trackingInfoHeader' | translate}}: {{id}}</div>
		<div fxFlex="10" fxLayoutAlign="end start">
			<button color="secondary" mat-dialog-close mat-icon-button>
				<mat-icon>close</mat-icon>
			</button>
		</div>
</div>
<mat-dialog-content>
	<app-tracking-progress *ngIf="user && shipmentDetail && shipmentDetail?.showStatusBar" [stop]="shipmentDetail" [user]="user"></app-tracking-progress>
	<div *ngIf="showMap">
		<div class="driver-location-wrapper">
			<app-driver-location [showFullScreen]="true" [stop]="shipmentDetail"></app-driver-location>
		</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="left-right-margins">
		<div *ngIf="shipmentDetail?.showDriverTracking">
			<button (click)="showMap = !showMap" color="primary" mat-button>
				{{showMap ? 'Hide' : 'Show'}} Driver Location
			</button>
		</div>
		<div *ngIf="shipmentDetail?.numStopsAway != null">{{shipmentDetail?.numStopsAway}} Stops Away</div>
	</div>
	<div fxLayout="row" fxLayoutGap="15px">
		<div fxFlex fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="5px">
				<div *ngIf="shipmentDetail?.routeId" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.routeIdLabel' | translate}}</div>
					<div>{{shipmentDetail?.routeId}}</div>
				</div>
				<div *ngIf="shipmentDetail?.custId || shipmentDetail?.custName"
					class="bottom-border-row" fxLayout="column" fxLayoutAlign="space-between">
					<div *ngIf="shipmentDetail?.custId" fxLayout="row" fxLayoutAlign="space-between">
						<div class="label">Customer ID</div>
						<div>{{shipmentDetail?.custId}}</div>
					</div>
					<br/>
					<div *ngIf="shipmentDetail?.custName" fxLayout="row" fxLayoutAlign="space-between">
						<div class="label">Customer Name</div>
						<div>{{shipmentDetail?.custName}}</div>
					</div>
				</div>
				<div *ngIf="shipmentDetail?.type !== 'ROUTESTOP' && ((!user?.token && (shipmentDetail?.origin?.name || shipmentDetail?.origin?.address1 ||
					shipmentDetail?.origin?.city || shipmentDetail?.origin?.state || shipmentDetail?.origin?.zip ||
					shipmentDetail?.origin?.originComments || shipmentDetail?.origin?.contact || shipmentDetail?.origin?.phone)) ||
					(user?.token && user?.globalSettings?.displayAddressesOnOrderTrackingPage))"
					 class="bottom-border-row" fxLayout="column" fxLayoutAlign="space-between">
					<div class="label shift-label-up">{{'trackOrderDetailsView.originLabel' | translate}}</div>
					<div class="address-wrapper" fxLayout="column" fxLayoutAlign="start top">
						<div *ngIf="shipmentDetail?.origin?.name">{{shipmentDetail?.origin?.name}}</div>
						<div *ngIf="shipmentDetail?.origin?.address1">{{shipmentDetail?.origin?.address1}} {{shipmentDetail?.origin?.address2}}</div>
						<div *ngIf="shipmentDetail?.origin?.city || shipmentDetail?.origin?.state || shipmentDetail?.origin?.zip">
							{{shipmentDetail?.origin?.city}}<span *ngIf="shipmentDetail?.origin?.city && shipmentDetail?.origin?.state">, </span>
							{{shipmentDetail?.origin?.state}} {{shipmentDetail?.origin?.zip}}
						</div>
						<div *ngIf="shipmentDetail?.origin?.originComments ">{{shipmentDetail?.origin?.originComments}}</div>
					</div>
					<div *ngIf="shipmentDetail?.origin?.contact" fxLayout="row" fxLayoutAlign="space-between">
						<div class="label">Contact</div>
						<div>{{shipmentDetail?.origin?.contact}}</div>
					</div>
					<div *ngIf="shipmentDetail?.origin?.phone" fxLayout="row" fxLayoutAlign="space-between">
						<div class="label">Phone</div>
						<div>{{shipmentDetail?.origin?.phone}}</div>
					</div>
				</div>
				<div *ngIf="(!user?.token && (shipmentDetail?.destination?.name || shipmentDetail?.destination?.address1 || shipmentDetail?.destination?.city ||
						shipmentDetail?.destination?.state || shipmentDetail?.destination?.zip || shipmentDetail?.destination?.destComments ||
						shipmentDetail?.destination?.contact || shipmentDetail?.destination?.phone)) || (user?.token && user?.globalSettings?.displayAddressesOnOrderTrackingPage)"
						class="bottom-border-row" fxLayout="column" fxLayoutAlign="space-between">
					 <div>
						<div class="label shift-label-up">{{shipmentDetail?.type === 'ROUTESTOP' ? 'Location' : 'Destination'}}</div>
						<div class="address-wrapper" fxLayout="column" fxLayoutAlign="start top">
							<div *ngIf="shipmentDetail?.destination?.name">{{shipmentDetail?.destination?.name}}</div>
							<div *ngIf="shipmentDetail?.destination?.address1">{{shipmentDetail?.destination?.address1}} {{shipmentDetail?.destination?.address2}}</div>
							<div *ngIf="shipmentDetail?.destination?.city || shipmentDetail?.destination?.state || shipmentDetail?.destination?.zip">
								{{shipmentDetail?.destination?.city}}<span *ngIf="shipmentDetail?.destination?.city && shipmentDetail?.destination?.state">, </span>
								{{shipmentDetail?.destination?.state}} {{shipmentDetail?.destination?.zip}}
							</div>
							<div *ngIf="shipmentDetail?.destination?.destComments">{{shipmentDetail?.destination?.destComments}}</div>
						</div>
					</div>
					<div *ngIf="shipmentDetail?.destination?.contact" fxLayout="row" fxLayoutAlign="space-between">
						<div class="label">Contact</div>
						<div>{{shipmentDetail?.destination?.contact}}</div>
					</div>
					<div *ngIf="shipmentDetail?.destination?.phone" fxLayout="row" fxLayoutAlign="space-between">
						<div class="label">Phone</div>
						<div>{{shipmentDetail?.destination?.phone}}</div>
					</div>
				</div>
				<div *ngIf="shipmentDetail?.statusDescription" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between center">
					<div class="label" fxLayoutAlign="start center">{{'trackOrderDetailsView.statusLabel' | translate}}
						<mat-icon *ngIf="user?.token && shipmentDetail.statusDescription === 'CANCELED'"
								  [matTooltip]="'This order was canceled by ' + shipmentDetail?.canceledBy + ' on ' + (shipmentDetail?.statusTimestamp?.formattedDate) + ' ' + (shipmentDetail?.statusTimestamp?.formattedTime) + ' ' + (shipmentDetail?.statusTimestamp.timezZone)"
								  color="warn"
								  matTooltipPosition="right">
							warning
						</mat-icon>
					</div>
					<div [ngClass]="{'warning-text' : shipmentDetail?.exceptions?.length > 0, 'success-text' : shipmentDetail?.statusDescription === 'DELIVERED', 'danger-text' : shipmentDetail?.statusDescription === 'CANCELED'}">
						{{shipmentDetail?.statusDescription}}
					</div>
				</div>
				<div *ngIf="shipmentDetail?.billingGroup" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{selectedCustomer?.captions?.billingGroupCaption ? selectedCustomer?.captions?.billingGroupCaption : 'Billing Group / Cost Center'}}</div>
					<div>{{shipmentDetail?.billingGroup}}</div>
				</div>
				<div *ngIf="shipmentDetail?.typeDescription" class="bottom-border-row"
					 fxLayout="row wrap" fxLayoutAlign="space-between">
					<div *ngIf="shipmentDetail?.shipmentSummary?.type === 'ONDEMAND'" class="label">{{'trackOrderDetailsView.orderTypeLabel' | translate}}</div>
					<div *ngIf="shipmentDetail?.shipmentSummary?.type === 'ROUTESTOP'" class="label">{{'trackOrderDetailsView.stopTypeLabel' | translate}}</div>
					<div>{{shipmentDetail?.typeDescription}}</div>
				</div>
				<div *ngIf="(!user?.token || (user?.token && !user?.inetUser?.hideRates)) && shipmentDetail?.charges && shipmentDetail?.shipmentSummary?.type !== 'ROUTESTOP'"
					 class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.chargesLabel' | translate}}</div>
					<div>{{shipmentDetail?.charges | currency:'USD':'symbol':'1.2-2'}}</div>
				</div>
				<div *ngIf="shipmentDetail?.createdBy" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.orderedByLabel' | translate}}</div>
					<div>{{shipmentDetail?.createdBy}}</div>
				</div>
				<div *ngIf="shipmentDetail?.sequence" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.sequenceLabel' | translate}}</div>
					<div>{{shipmentDetail?.sequence}}</div>
				</div>
				<div *ngIf="shipmentDetail?.readyTimeFrom" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.pickupReadyLabel' | translate}}</div>
					<div>{{shipmentDetail?.readyTimeFrom?.formattedDate}} {{shipmentDetail?.readyTimeFrom?.formattedTime}} {{shipmentDetail?.readyTimeFrom?.timeZone}}</div>
				</div>
				<div *ngIf="shipmentDetail?.dueTimeTo" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.deliverByLabel' | translate}}</div>
					<div>{{shipmentDetail?.dueTimeTo?.formattedDate}} {{shipmentDetail?.dueTimeTo?.formattedTime}} {{shipmentDetail?.dueTimeTo?.timeZone}}</div>
				</div>
				<div *ngIf="user?.token" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.piecesWeightLabel' | translate}}</div>
					<div>{{shipmentDetail?.pieces}} / {{shipmentDetail?.weight}}</div>
				</div>
				<div *ngIf="!user?.token && shipmentDetail?.pieces" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Pieces</div>
					<div>{{shipmentDetail?.pieces}}</div>
				</div>
				<div *ngIf="!user?.token && shipmentDetail?.weight" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Weight</div>
					<div>{{shipmentDetail?.weight}}</div>
				</div>
				<div *ngIf="shipmentDetail?.parcelType?.description" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.packageInfoLabel' | translate}}</div>
					<div>{{shipmentDetail?.parcelType?.description}}</div>
				</div>
				<div *ngIf="shipmentDetail?.reference1" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{selectedCustomer?.captions?.referenceCaption ?
						selectedCustomer?.captions?.referenceCaption : 'Reference'}}
					</div>
					<div>{{shipmentDetail?.reference1}}</div>
				</div>
				<div *ngIf="shipmentDetail?.reference2" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{selectedCustomer?.captions?.referenceCaption2 ?
						selectedCustomer?.captions?.referenceCaption2 : 'Reference 2'}}
					</div>
					<div>{{shipmentDetail?.reference2}}</div>
				</div>
				<div *ngIf="shipmentDetail?.barcode" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.barcodeLabel' | translate}}</div>
					<div>{{shipmentDetail?.barcode}}</div>
				</div>
				<div *ngIf="shipmentDetail?.dispatched !== null" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.dispatchedLabel' | translate}}</div>
					<div>{{shipmentDetail?.dispatched?.formattedDate}} {{shipmentDetail?.dispatched?.formattedTime}} {{shipmentDetail?.dispatched?.timeZone}}</div>
				</div>
				<div *ngIf="shipmentDetail?.confirmed !== null" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.confirmedLabel' | translate}}</div>
					<div>{{shipmentDetail?.confirmed?.formattedDate}} {{shipmentDetail?.confirmed?.formattedTime}} {{shipmentDetail?.confirmed?.timeZone}}</div>
				</div>
				<div *ngIf="shipmentDetail?.atOrigin !== null" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.atPickupLabel' | translate}}</div>
					<div>{{shipmentDetail?.atOrigin?.formattedDate}} {{shipmentDetail?.atOrigin?.formattedTime}} {{shipmentDetail?.atOrigin?.timeZone}}</div>
				</div>
				<div *ngIf="shipmentDetail?.atDestination !== null" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.atDeliveryLabel' | translate}}</div>
					<div>{{shipmentDetail?.atDestination?.formattedDate}} {{shipmentDetail?.atDestination?.formattedTime}} {{shipmentDetail?.atDestination?.timeZone}}</div>
				</div>
			</div>
			<div *ngIf="shipmentDetail?.exceptions?.length !== 0 && (shipmentDetail?.showStatusCodeDescription || shipmentDetail?.showStatusCodeComment || shipmentDetail?.showStatusCodeTime)">
				<h3>{{'trackOrderDetailsView.statusCodesHeader' | translate}}:</h3>
				<div class="mat-table-wrapper">
					<mat-table [dataSource]="shipmentDetail?.exceptions">
						<ng-container matColumnDef="code">
							<mat-header-cell *matHeaderCellDef>
								{{'trackOrderDetailsView.codeColumnHeader' | translate}}
							</mat-header-cell>
							<mat-cell *matCellDef="let element"
									  [attr.data-label]="'trackOrderDetailsView.codeColumnHeader' | translate">
								{{element?.statusCode}} - {{element?.description}}
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="comment">
							<mat-header-cell *matHeaderCellDef>
								{{'trackOrderDetailsView.commentColumnHeader' | translate}}
							</mat-header-cell>
							<mat-cell *matCellDef="let element"
									  [attr.data-label]="'trackOrderDetailsView.commentColumnHeader' | translate">
								{{element?.statusComment}}
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="time">
							<mat-header-cell *matHeaderCellDef>
								{{'trackOrderDetailsView.timeColumnHeader' | translate}}
							</mat-header-cell>
							<mat-cell *matCellDef="let element"
									  [attr.data-label]="'trackOrderDetailsView.timeColumnHeader' | translate">
								{{element?.createdWhen?.formattedDate}} {{element?.createdWhen?.formattedTime}}
							</mat-cell>
						</ng-container>
						<mat-header-row *matHeaderRowDef="exceptionColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: exceptionColumns;">
						</mat-row>
					</mat-table>
				</div>
			</div>
			<div>
			<app-parcels (addParcel)="handelAddParcel($event)"
						 (editParcel)="handelEditParcel($event)"
						 [parcels]="shipmentDetail?.parcels"
						 [id]="shipmentDetail?.shipmentSummary?.id"
						 [type]="shipmentDetail?.type"
						 [areParcelsEditable]="shipmentDetail?.areParcelsEditable">
			</app-parcels>
			</div>
			<div>
				<app-attachment-list [access]="2" [podAttachments]="podAttachments"
									 [regularAttachments]="regularAttachments" [user]="user"
									 [workOrder]="{attachments: shipmentDetail?.attachmentDetails, id: shipmentDetail?.shipmentSummary?.id, type: shipmentDetail?.type}"></app-attachment-list>
			</div>
			<div *ngIf="shipmentDetail?.driverPhotos?.length > 0"
				 fxLayout="column" fxLayoutGap="15px">
				<h3>Your Delivery Driver(s)</h3>
				<div (click)="openDriverPhoto(d)" *ngFor="let d of shipmentDetail?.driverPhotos"
					 fxLayout="row"
					 fxLayoutAlign="start center" fxLayoutGap="15px">
					<mat-icon *ngIf="!d?.photo">account_box</mat-icon>
					<img *ngIf="d?.photo" [src]="d?.photo" class="photo-thumbnail"/>
					<span [ngClass]="{'clickable' : d.photo}">{{d?.firstName}} {{d?.lastName}}</span>
				</div>
			</div>
			<div *ngIf="shipmentDetail?.pod || shipmentDetail?.podComment || shipmentDetail?.signature"
				 fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
				<h3>{{'trackOrderDetailsView.podHeader' | translate}}:</h3>
				<div *ngIf="shipmentDetail?.pod" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.podLabel' | translate}}</div>
					<div>{{shipmentDetail?.pod}}</div>
				</div>
				<div *ngIf="shipmentDetail?.podComment" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">{{'trackOrderDetailsView.commentsLabel' | translate}}</div>
					<div id="podComment">{{shipmentDetail?.podComment}}</div>
				</div>
				<img *ngIf="shipmentDetail?.signature" [src]="shipmentDetail?.formattedSignature" class="pod-image"/>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions>

</mat-dialog-actions>
